'use client';

import React from 'react';
import { InteractiveCard } from "../../lib/types";
import CardSection from "./CardSection";

interface InteractiveCardsSectionProps {
  interactiveCards: InteractiveCard[];
  title?: string;
  body?: string;
  ctaOneText?: string;
  ctaOneLink?: string;
  ctaTwoText?: string;
  ctaTwoLink?: string;
}

// Demo interactive card data (fallback when no Contentful data)
const demoInteractiveCards: InteractiveCard[] = [
  { cardTitle: "Digital Strategy", description: "Comprehensive digital strategies that drive business growth" },
  { cardTitle: "Experience Design", description: "Creating meaningful user experiences across all touchpoints" },
  { cardTitle: "Technology Innovation", description: "Leveraging cutting-edge technology to solve complex problems" },
  { cardTitle: "Data Analytics", description: "Transforming data into actionable insights" },
  { cardTitle: "Brand Development", description: "Building strong brands that resonate with audiences" },
  { cardTitle: "Content Strategy", description: "Crafting compelling content that engages and converts" }
];

export default function InteractiveCards({ 
  interactiveCards, 
  title, 
  body, 
  ctaOneText, 
  ctaOneLink, 
  ctaTwoText, 
  ctaTwoLink 
}: InteractiveCardsSectionProps) {
  // Use Contentful data or fallback to demo data
  const displayInteractiveCards = interactiveCards && interactiveCards.length > 0 ? interactiveCards : demoInteractiveCards;

  return (
    <section 
      className="interactive-cards w-full overflow-x-hidden"
      style={{
        backgroundImage: 'radial-gradient(circle at 0.0625rem 0.0625rem, #8DC1FF 0.0625rem, transparent 0)',
        backgroundSize: '1.25rem 1.25rem',
      }}
    >
      <div className="max-w-[120rem] mx-auto">
        <CardSection
          items={displayInteractiveCards.map((c, i) => ({
            id: i,
            imageSrc: (c.cardPicture && c.cardPicture.length > 0) ? c.cardPicture : '/images/gallery/gallery-01.jpg',
            alt: c.cardTitle || 'Interactive card',
            // Use cardTitle for tooltip (the main title from Contentful)
            extraLine: c.cardTitle,
          }))}
          title={title}
          body={body}
          defaultTitle="Who we are"
          defaultBody="Independent minds, collective impact."
          hoverBackgroundColor="#328CF5"
          cardWidth={310}
          cardHeight={420}
          overlapPx={100}
          radiusPx={12}
          ctaOneText={ctaOneText}
          ctaOneLink={ctaOneLink}
          ctaTwoText={ctaTwoText}
          ctaTwoLink={ctaTwoLink}
          showTooltip={true}
          maxPerRow={6}
        />
      </div>
    </section>
  );
}
